import { instance } from "../index";
// API call to get a gift code by its code/link
export const getGiftCodeByLink = async (code) => {
  const response = await instance.get(`/api/gift-code/code/${code}`);
  return response.data;
};

// API call to reveal a gift code (like scratching a card)
// Updated to accept userData for when user details are required
export const revealGiftCode = async (code, userData = {}) => {
  const response = await instance.put(
    `/api/gift-code/reveal/${code}`,
    userData
  );
  return response.data;
};

// API call to redeem a gift code after it's been revealed
export const redeemGiftCode = async (code, userData = {}) => {
  const response = await instance.post(
    `/api/gift-code/redeem/${code}`,
    userData
  );
  return response.data;
};
